import type { JSX } from "preact";
import { Link } from "wouter-preact";
import { BackArrow } from "@gss/components/icons";
import { useTranslation } from "../util/Translation";

interface Props {
    href?: string;
}

export function Back({ href }: Props): JSX.Element {
    const t = useTranslation().translation.misc;
    return (
        <Link href={href ?? "/"} className="text-decoration-none">
            <BackArrow aria-hidden />
            {t.back}
        </Link>
    );
}
